import React from "react"
import SortableTableHeader from "../../common/sortableTableHeader"
import PropTypes from "prop-types"

const HearingInstrumentsTable = ({
  sort,
  setSorting,
  hearingInstruments = [],
}) => {
  const setSort = (sortField) => () => {
    setSorting(sortField)
  }

  const headers = [
    { name: "hiName", label: "Hearing Instrument Name", className: "col-md-2" },
    {
      name: "brandDisplayId",
      label: "Brand Display ID",
      className: "col-md-2",
    },
    {
      name: "brandDisplayName",
      label: "Brand Display Name",
      className: "col-md-4",
    },
    {
      name: "supportsRemoteFitting",
      label: "Supports Remote Fitting",
      className: "col-md-4",
    },
    {
      name: "supportsPersistentRemoteTuning",
      label: "Supports Persistent Remote Tuning",
      className: "col-md-4",
    },
    { name: "platform", label: "Platform", className: "col-md-2" },
    {
      name: "hiTypeId",
      label: "Hearing Instrument Type ID",
      className: "col-md-2",
    },
  ]

  const optionYes = (
    <span>
      <i className="fa fa-check fa-md" /> Yes
    </span>
  )
  const optionNo = (
    <span>
      <i className="fa fa-times fa-md" /> No
    </span>
  )

  return (
    <table className="table table--users mt-5">
      <thead>
        <tr>
          {headers.map((h) => (
            <SortableTableHeader
              key={h.name}
              className={h.className}
              name={h.name}
              onClick={setSort(h.name)}
              value={h.label}
              sort={sort}
            />
          ))}
        </tr>
      </thead>
      <tbody>
        {Object.keys(hearingInstruments).map((instrumentId) => {
          const instrument = hearingInstruments[instrumentId]
          return (
            <tr key={instrument.id}>
              <td>
                <a href={"/hearingInstrument/" + instrument.id}>
                  {instrument.hiName}
                </a>
              </td>
              <td>{instrument.brandDisplayId}</td>
              <td>{instrument.brandDisplayName}</td>
              <td>{instrument.supportsRemoteFitting === "true" ? optionYes : optionNo}</td>
              <td>
                {instrument.supportsPersistentRemoteTuning === "true" ? optionYes : optionNo}
              </td>
              <td>{instrument.platform}</td>
              <td>{instrument.hiTypeId}</td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
HearingInstrumentsTable.propTypes = {
  sort: PropTypes.string.isRequired,
  setSorting: PropTypes.func.isRequired,
  hearingInstruments: PropTypes.array.isRequired,
}

export default HearingInstrumentsTable
